import React, { useState } from 'react';
import { MdBusiness, MdEmail } from 'react-icons/md';
import API from '../api';
import { useLanguage } from '../i18n';

export default function ForgotPassword() {
    const { t } = useLanguage();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async event => {
        event.preventDefault(); setLoading(true); setError(''); setMessage('');
        try {
            const { data } = await API.post('/auth/forgot-password', { email });
            setMessage(data.message);
        } catch (err) { setError(err.response?.data?.error || t('account.resetEmailFailed')); }
        finally { setLoading(false); }
    };

    return <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#edf5ff,#b8d6ff)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 18, padding: 32, boxShadow: '0 22px 48px rgba(9,32,64,.18)' }}>
            <div style={{ textAlign: 'center', marginBottom: 24 }}><MdBusiness size={42} style={{ color: '#0b5ed7' }} /><h4 style={{ fontWeight: 700, margin: '8px 0 4px' }}>{t('account.forgotTitle')}</h4><p style={{ color: '#64748b', fontSize: 13, margin: 0 }}>{t('account.forgotDescription')}</p></div>
            {error && <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>{error}</div>}
            {message && <div className="alert alert-success" style={{ fontSize: 13 }}>{message}</div>}
            <form onSubmit={submit}><label className="form-label" style={{ fontSize: 13 }}>{t('login.email')}</label><div style={{ position: 'relative' }}><MdEmail style={{ position: 'absolute', left: 12, top: 11, color: '#94a3b8' }} /><input type="email" className="form-control mb-4" style={{ paddingLeft: 36 }} value={email} onChange={event => setEmail(event.target.value)} required /></div><button className="btn btn-primary w-100" disabled={loading}>{loading ? t('account.sending') : t('account.sendResetLink')}</button></form>
            <a href="/login" className="d-block text-center mt-3" style={{ fontSize: 13 }}>{t('account.backToLogin')}</a>
        </div>
    </div>;
}
